import React, { useRef, useState, useEffect, useLayoutEffect } from 'react'
import { useSelector } from "react-redux";
import axios from 'axios';
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Checkbox from "@mui/material/Checkbox";
import FlagIcon from '@mui/icons-material/Flag';
import TextField from "@mui/material/TextField";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import FormControl from "@mui/material/FormControl";
import Autocomplete from "@mui/material/Autocomplete";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import CloseIcon from "@mui/icons-material/Close";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import FroalaEditorComponent from "../froalaHtmlEditor/FroalaEditorComponent";
import config_settings from '../../config/config';
import LocationInput from './LocationInput';
import "../../../assets/styles/containers/_commentFilter.scss";

let BASE_URL;

const origin = () => {
    let origin = window.location.origin.toLowerCase();
    if (origin.includes("https://")) origin = origin.replace("https://", "");
    else origin = origin.replace("http://", "");
    BASE_URL = config_settings[origin]?.SERVER_URL;
};

origin();

const froalaConfig = {
    imagePaste: false,
    spellCheck: true,
    heightMin: 145,
    heightMax: 201,
    linkAutoPrefix: 'https://',
    linkAlwaysBlank: true,
    toolbarButtons: {
        moreText: { buttons: ['bold', 'italic', 'underline', '|', 'fontFamily', 'fontSize', 'textColor', 'backgroundColor'], align: 'left', buttonsVisible: 7 },
        moreParagraph: { buttons: ['|', 'alignLeft', 'alignCenter', 'alignRight', 'formatOLSimple', 'formatUL'], align: 'left', buttonsVisible: 8 },
        moreRich: { buttons: ['|', "insertLink", "outdent", "indent"], align: "left", buttonsVisible: 1 },
        moreMisc: { buttons: ['undo', 'redo', 'selectAll', 'html', 'clearFormatting'], align: 'right', buttonsVisible: 2 }
    },
    toolbarButtonsXS: [['fontFamily', 'fontSize', 'bold', 'italic', 'underline', '|'], ['undo', 'redo']],
    pluginsEnabled: ["wordPaste", "spellChecker", "codeBeautifier", "fontFamily", "fontSize", "colors", "align", "lists", 'paragraphFormat', "link"],
};

function AddNewCommentNN(props) {
    const { value, newCommentTabIndex, setStateData, stateData, TabPanel, AllCategoryList, recommendation, editorContent, setEditorContent, newOpen, editComment } = props;
    const { commentTitle, commentTag, commentRating, commentLocation, selectedFilterTagID } = stateData;
    const storeData = useSelector((state) => state.CommonReducer);
    const editorRef = useRef();
    const tagsAutocompleteRootRef = useRef(null);
    const initialTagPrefillDoneRef = useRef(false);
    const [tagsDropdownOpen, setTagsDropdownOpen] = useState(false);
    const [tagsFieldFocused, setTagsFieldFocused] = useState(false);
    const [maxTagsByWidth, setMaxTagsByWidth] = useState(3);
    const ratingsMap = AllCategoryList?.template?.rating_data;
    const locationData = AllCategoryList?.template?.location_data;
    const [state, setState] = useState({
        tagsList: [],
    });
    const { tagsList } = state

    useEffect(() => {
        if (!sessionStorage.getItem("company_id")) return;
        const controller = new AbortController();
        async function fetchTags() {
            try {
                const companyID = sessionStorage.getItem("company_id");
                const token = sessionStorage.getItem("token");
                const res = await axios.get(`${BASE_URL}/filter-tag-list`, {
                    params: { company_id: companyID },
                    signal: controller.signal,
                    headers: { "Authorization": `Bearer ${token}`, "company-key": companyID },
                });
                setState(prevState => ({ ...prevState, tagsList: res?.data?.data ?? [] }));
            } catch (err) {
                if (!axios.isCancel(err)) console.error("TAGS API error:", err);
            }
        }
        fetchTags();
        return () => controller.abort();
    }, [sessionStorage.getItem("company_id")]);

    useEffect(() => {
        if (editComment) return;
        if (initialTagPrefillDoneRef.current) return;
        if (!Array.isArray(selectedFilterTagID) || selectedFilterTagID.length === 0) return;
        if (Array.isArray(commentTag) && commentTag.length > 0) return;

        const fastSourceTags = Array.isArray(storeData?.clTagNN) ? storeData.clTagNN : [];
        const availableTags = (Array.isArray(tagsList) && tagsList.length > 0) ? tagsList : fastSourceTags;
        if (!Array.isArray(availableTags) || availableTags.length === 0) return;

        const selectedFilterIds = selectedFilterTagID.map((id) => String(id));
        const preselectedTags = availableTags
            .filter((tag) => selectedFilterIds.includes(String(tag?.id)))
            .map((tag) => ({
                id: tag?.id,
                name: tag?.title || tag?.name,
                color: tag?.color || tag?.Color,
            }));

        if (preselectedTags.length > 0) {
            setStateData((prev) => ({ ...prev, commentTag: preselectedTags }));
            initialTagPrefillDoneRef.current = true;
        }
    }, [editComment, selectedFilterTagID, tagsList, commentTag, setStateData, storeData?.clTagNN]);

    useLayoutEffect(() => {
        const root = tagsAutocompleteRootRef.current;
        if (!root) return;
        const measure = () => {
            const w = root.getBoundingClientRect().width;
            if (!w) return;
            const reservedForInput = 110;
            const avgChipWidth = 92;
            const plusLabelReserve = 44;
            const available = w - reservedForInput - plusLabelReserve;
            const n = Math.floor(Math.max(0, available) / avgChipWidth);
            setMaxTagsByWidth(Math.max(1, Math.min(n || 1, 50)));
        };
        measure();
        const ro = new ResizeObserver(measure);
        ro.observe(root);
        return () => ro.disconnect();
    }, []);

    // ---------------- FETCH LOCATIONS (for Location Autocomplete) ----------------
    // useEffect(() => {
    //     if (!sessionStorage.getItem("company-key")) return;
    //     const controller = new AbortController();
    //     async function fetchLocations() {
    //         try {
    //             const companyID = sessionStorage.getItem("company-key");
    //             const res = await axios.get(`${BASE_URL}/locations`, {
    //                 // params: { company_id: companyID },
    //                 signal: controller.signal,
    //                 headers: { "Content-Type": "application/json", "company-key": companyID },
    //             });
    //             const data = res?.data?.data ?? [];
    //             setState(prevState => ({ ...prevState, locationOptions: data }));
    //         } catch (err) {
    //             if (!axios.isCancel(err)) console.error("LOCATIONS API error:", err);
    //         }
    //     }
    //     fetchLocations();
    //     return () => controller.abort();
    // }, [sessionStorage.getItem("company-key")]);

    // ---------------- FETCH RATINGS (for Rating Autocomplete) ----------------
    // useEffect(() => {
    //     if (!sessionStorage.getItem("company-key")) return;
    //     const controller = new AbortController();
    //     async function fetchRatings() {
    //         try {
    //             const companyID = sessionStorage.getItem("company-key");
    //             const res = await axios.get(`${BASE_URL}/ratings`, {
    //                 signal: controller.signal,
    //                 headers: { "company-key": companyID },
    //             });
    //             const data = res?.data?.data ?? [];
    //             setState(prevState => ({ ...prevState, ratingOptions: data }));
    //         } catch (err) {
    //             if (!axios.isCancel(err)) console.error("RATINGS API error:", err);
    //         }
    //     }
    //     fetchRatings();
    //     return () => controller.abort();
    // }, [sessionStorage.getItem("company-key")]);

    const handleChange = (name, content) => {
        setEditorContent(prevState => ({ ...prevState, innerHTML: content.replace(/<([a-zA-Z0-9]+)>\s*<\/\1>\s*/g, ""), }));
    };

    const handleChangeTag = (name, value) => {
        const modifiedArray = value.map((obj) => ({
            id: obj.id,
            name: obj.title || obj.name,
            color: obj.color,
        }));
        setStateData((prev) => ({ ...prev, [name]: modifiedArray }));
    };

    const resolveTagTextColor = (bg) => {
        const c = String(bg || "").toLowerCase();
        if (!c) return "#FFFFFF";
        if (c.includes("#fff") || c.includes("white")) return "#000000";
        return "#FFFFFF";
    };

    const handleChangeRating = (name, value) => {
        setStateData((prev) => ({ ...prev, [name]: value }));
    };

    const resolveColor = (item, ratingOptions = []) => {
        if (!item) return "#CED2DA";
        const live = (Array.isArray(ratingOptions) ? ratingOptions : []).find((o) => o.Id === item.Id);
        const c = (live || item).Color;
        if (typeof c === "string") return c;
        if (c && typeof c === "object") return c.hex ?? c.code ?? c.value ?? c.name ?? "#CED2DA";
        return "#CED2DA";
    };

    const isTruthy = (v) => {
        if (v == null) return false;
        if (typeof v === "boolean") return v;
        if (typeof v === "number") return v !== 0;
        if (typeof v === "string") return ["1", "true", "yes", "y"].includes(v.toLowerCase());
        return false;
    };

    const resolveIncludeInSummary = (item, ratingOptions = []) => {
        if (!item) return false;
        const live = (Array.isArray(ratingOptions) ? ratingOptions : []).find((o) => o.Id === item.Id) || item;
        let v =
            parseInt(live.include_in_summary) ??
            live.includeInSummary ??
            live.is_flagged ??
            live.isFlagged ??
            live.flag ??
            live.include ??
            live?.summary?.include_in_summary;
        if (v && typeof v === "object") v = v.value ?? v.enabled ?? v.bool ?? v.checked ?? v.flag;
        return isTruthy(v);
    };

    const resolveName = (item, ratingOptions = []) => {
        if (!item) return "";
        const live = (Array.isArray(ratingOptions) ? ratingOptions : []).find((o) => o.Id === item.Id) || item;
        return live?.Name ?? "";
    };

    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" />;
    const tagsExpanded = tagsFieldFocused || tagsDropdownOpen;

    return (
        <TabPanel value={value} index={newCommentTabIndex} className="tab_panel_cLibrary">
            <Grid container>
                <Grid item container xs={7.5} pr={1}>
                    <Grid item xs={12} mt={2}>
                        <FormControl variant="standard" className="forms-control">
                            <label className="non-narrative-comment-label" htmlFor="title">
                                Title
                            </label>
                            <TextField id="comment_title" size="small" variant="outlined" placeholder="Comment title" value={commentTitle} onChange={(e) => setStateData(prevState => ({ ...prevState, commentTitle: e.target.value }))} type="text" />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} mb={2} >
                        <FormControl fullWidth variant="standard" className="forms-control">
                            <label className="cl-new-comment-input-form-label">RATING</label>
                            <Autocomplete
                                multiple
                                size="small"
                                limitTags={2}
                                options={ratingsMap || []}
                                value={commentRating || []}
                                onChange={(e, value) => handleChangeRating("commentRating", value)}
                                isOptionEqualToValue={(option, value) => (option.Id === value.Id)}
                                disableCloseOnSelect
                                getOptionLabel={(option) => option?.Name}
                                renderTags={(value, getTagProps) =>
                                    value.map((option, index) => {
                                        const tagProps = getTagProps({ index });
                                        const color = resolveColor(option, ratingsMap);
                                        const flagged = resolveIncludeInSummary(option, ratingsMap);
                                        return (
                                            <Box
                                                key={option?.Id}
                                                {...tagProps}
                                                sx={{
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    gap: 0.75,
                                                    px: 0.5,
                                                    py: 0,
                                                    pl: 1,
                                                    borderRadius: "16px",
                                                    backgroundColor: "#FFF",
                                                    border: "1px solid #CED2DA",
                                                    color: "#637083",
                                                    fontSize: 12,
                                                    fontWeight: 600,
                                                }}
                                            >
                                                <span style={{ height: 15, width: 15, backgroundColor: color, borderRadius: 5, marginLeft: 8 }} >
                                                    {flagged ? <FlagIcon sx={{ color: "white", fontSize: 15 }} /> : null}
                                                </span>
                                                <span
                                                    style={{
                                                        maxWidth: 140,
                                                        color: "#637083",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        whiteSpace: "nowrap",
                                                        marginTop: 2,
                                                    }}
                                                >
                                                    {resolveName(option, ratingsMap)}
                                                </span>
                                                <IconButton size="small" onClick={tagProps.onDelete} sx={{ height: 20, width: 20, ml: 0.25, color: "#fff", backgroundColor: "#97A1AF", marginRight: 0.5 }}>
                                                    <CloseOutlinedIcon sx={{ fontSize: 14 }} />
                                                </IconButton>
                                            </Box>
                                        );
                                    })
                                }
                                renderOption={(props, option, { selected }) => (
                                    <li {...props} key={option?.id || option.Id}>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            checked={(commentRating || [])?.some((rating) => (rating.Id === option.Id))}
                                        />
                                        <Box
                                            sx={{
                                                width: 15,
                                                height: 15,
                                                backgroundColor: option?.Color,
                                                borderRadius: "2px",
                                                marginRight: 1,
                                            }}
                                        >
                                            {parseInt(option?.include_in_summary) === 1 ? <FlagIcon sx={{ color: "white", fontSize: 15, mb: 0.3 }} /> : ""}
                                        </Box>
                                        {option?.Name || ""}
                                    </li>
                                )}
                                renderInput={(params) => (
                                    <TextField {...params} variant="outlined" placeholder={(commentRating || []).length === 0 ? "No ratings selected" : ""} />
                                )}
                            />
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid item container xs={4.5} alignItems="flex-start" style={{ alignSelf: 'flex-start' }}>
                    <Grid item xs={12} mt={2}>
                        <FormControl variant="standard" className="forms-control">
                            <label className="non-narrative-comment-label" htmlFor="tags">
                                TAGS
                            </label>
                            <Box ref={tagsAutocompleteRootRef} sx={{ width: "100%" }}>
                            <Autocomplete
                                multiple
                                size="small"
                                className="filter-tags-textfield"
                                sx={{
                                    ml: "8px",
                                    width: "100%",
                                    "& .MuiOutlinedInput-root": {
                                        flexWrap: "wrap",
                                        minHeight: 37,
                                        height: tagsExpanded ? "auto" : 37,
                                        alignItems: "center",
                                    },
                                    "& .MuiOutlinedInput-root.MuiInputBase-sizeSmall .MuiAutocomplete-input": { padding: "2.5px 4px 3.5px 8px" },
                                }}
                                options={tagsList || []}
                                value={commentTag}
                                onOpen={() => setTagsDropdownOpen(true)}
                                onClose={() => setTagsDropdownOpen(false)}
                                onChange={(e, value) => handleChangeTag("commentTag", value)}
                                disableCloseOnSelect
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                getOptionLabel={(option) => option?.name || ""}
                                renderTags={(value, getTagProps) => {
                                    const limit = tagsExpanded ? value.length : Math.min(value.length, maxTagsByWidth);
                                    const visible = value?.slice(0, limit) || [];
                                    const hiddenCount = value.length - visible.length;
                                    return (
                                        <>
                                            {visible.map((option, index) => (
                                                <Chip
                                                    key={option?.id ?? `${option?.name}-${index}`}
                                                    size="small"
                                                    style={{
                                                        borderRadius: "35px",
                                                        border: "1px solid #CED2DA",
                                                        backgroundColor: option?.color || option?.Color,
                                                        color: resolveTagTextColor(option?.color || option?.Color),
                                                    }}
                                                    deleteIcon={
                                                        <div
                                                            style={{
                                                                backgroundColor: "#000000",
                                                                borderRadius: "50%",
                                                                height: "16px",
                                                                width: "16px",
                                                                display: "flex",
                                                                justifyContent: "center",
                                                                alignItems: "center",
                                                            }}
                                                        >
                                                            <CloseIcon style={{ color: "white", height: "14px", width: "14px" }} />
                                                        </div>
                                                    }
                                                    label={<span className="filter-tags-lable">{option?.name || option?.title}</span>}
                                                    {...getTagProps({ index })}
                                                />
                                            ))}
                                            {hiddenCount > 0 && <Typography sx={{ ml: 0.5 }}>{`+${hiddenCount}`}</Typography>}
                                        </>
                                    );
                                }}
                                renderOption={(props, option, { selected }) => (
                                    <li {...props} key={option?.id}>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            checked={commentTag?.some((tag) => tag.id === option.id)}
                                        />
                                        <Box sx={{ width: 12, height: 12, backgroundColor: option?.color || option?.Color, borderRadius: "50%", marginRight: 1 }} />
                                        {option?.name}
                                    </li>
                                )}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        placeholder={(commentTag || []).length === 0 ? "Add tags" : ""}
                                        onFocus={(e) => {
                                            setTagsFieldFocused(true);
                                            params.inputProps?.onFocus?.(e);
                                        }}
                                        onBlur={(e) => {
                                            params.inputProps?.onBlur?.(e);
                                            window.setTimeout(() => setTagsFieldFocused(false), 0);
                                        }}
                                    />
                                )}
                            />
                            </Box>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} mt={-0.2}>
                        {AllCategoryList?.template?.is_hip_template !== 1 ? <FormControl fullWidth variant="standard" className="forms-control">
                            <label className="cl-new-comment-input-form-label">LOCATION</label>
                            <LocationInput
                                cmtLocHolder
                                nonHT={true}
                                action="comment"
                                locationData={locationData || []}
                                onApplySelection={(selected) => setStateData((prev) => ({ ...prev, commentLocation: selected }))}
                                locationValue={Array.isArray(commentLocation) ? commentLocation : (commentLocation ? [commentLocation] : [])}
                            />
                        </FormControl> : null}
                    </Grid>
                    <Grid container item xs={12}>
                    </Grid>
                </Grid>
                <Grid container className="input-controll">
                    <Grid item xs={12} sm={12}>
                        <FormControl variant="standard" className="forms-control">
                            <label className="non-narrative-comment-label" htmlFor="Comment">
                                Comment
                            </label>
                            <FroalaEditorComponent
                                showAI={false}
                                commentData={{ commentText: recommendation, comment_dropdowns: [] }}
                                editorData={editorContent}
                                editor={editorRef}
                                setEditorContent={setEditorContent}
                                id={"nonNarrativeComment"}
                                onChange={handleChange}
                                froalaConfig={froalaConfig}
                                type="add"
                                AllCategoryList={AllCategoryList}
                                filterTagList={tagsList}
                                newOpen={newOpen}
                            />
                        </FormControl>
                    </Grid>
                </Grid>
            </Grid>
        </TabPanel>
    )
}

export default AddNewCommentNN;